import ActionButtons from '@/components/organisms/ActionButtons';
import Footer from '@/components/organisms/Footer';
import TopNavigation from '@/components/organisms/TopNavigation';
import { MergeProps } from '@devsisters/wds-react';
import { PageProps } from 'gatsby';
import React from 'react';

type BaseProps = {
  children?: React.ReactNode;
};
type Props = MergeProps<PageProps, BaseProps>;
function RootLayout(props: Props) {
  const { location, children } = props;

  return (
    <>
      <TopNavigation location={location} />
      {children}

      <ActionButtons />
      <Footer />
    </>
  );
}

export default RootLayout;
